import './App.css';

function App() {
  return (
    <div className="container">
    <div className="title">Go Metro Lucknow</div> <br /> <br />

<strong>About the App</strong>

<p><strong>Go Metro Lucknow App </strong>is an application which helps to enhance the travelling experience of users using Lucknow metro by providing a simplified application that provides various data related to it.
</p>

<p>The application provides data related to Lucknow Metro such as ticket fare, card fare, station services, platforms, route, etc.
It is available in offline mode with a faster performance for the user.
</p>

<p>
Data available in the application is taken from the official site, Lucknow Metro and is subject to change.
The application is able to provide various necessary information in offline mode with faster performance for the user. Therefore, Any changes in the data may take time to reflect on the application.
</p>

<p>
<strong>
The app is not affiliated or represent any Metro/Metro Authority or government entity and is a third party app with the intention of assisting the users.
</strong>
</p>

<br />

<strong>Privacy Policy</strong>
<p>This privacy policy applies to the <strong>Go Metro Lucknow</strong> app (hereby referred to as "App/Application") for mobile devices that was created by <strong>Nabeel M Rizwan </strong> (hereby referred to as "Service Provider") as a Free service. 
This service is intended for use as in stated.</p>

<br />

<strong>Disclaimer</strong>

<p>This app is not affiliated with any metro authorities or government agencies. It is an independent application developed for informational purposes.
The app uses the Leaflet library for its map functionality. Please note that the map data and content displayed are not provided by the developer.
The developer is not responsible for the data displayed through Leaflet or any other third-party services integrated into the app.
<br />
<br />
By using this app, you acknowledge that any reliance on the app and its services is at your own discretion and risk.</p>




<br />

<strong>Information Collection and Use</strong>

<p>The Application may ask for user location permission for functionality. The functionality may work without the user location but would provide a better experience. </p>
<p>It is the user's decision whether he/she wants to share the location mainly for interactive map feature.</p>
<p>The app asks permission for location and if allowed, It sends the coordinates to Leaflet library (an open source map library) for pinning the user location on the interactive map.</p>
<p>No other user information except user location (with the app requesting permission) is collected or shared.</p>

<br />

<strong>Security</strong>

<p>There are <strong>no </strong>special access permission required to use the app and is free for download.</p>

<br />

<strong>Changes</strong>

<p>This Privacy Policy may be updated from time to time for any reason. The users will be informed about the changes of privacy policy by the updating of this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.</p>

<br />

<p>This privacy policy is effective as of 2025-01-28 (YYYY-MM-DD)</p>

<br />

<strong>Your Consent</strong>

<p>By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.
</p>

<br />

<strong>Contact Us</strong>

<p>If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at nabeel.rizwan.05@gmail.com.</p>

</div>
  );
}


export default App;
